import React from "react";

import { HashRouter as Router, Route } from "react-router-dom";
import { GlobalStateProvider } from "./StateManagement";
import { ConfigProvider } from "./ConfigProvider";
import { OTP } from "./Login";
import { initialState, State } from "./initialState";
import { wrapWithMetrics } from "./metrics/configureMetrics";
import { LoginPanelMaster } from "./panels";
import { restoreWithDefault } from "./StateManagement/LocalStorageService";

const initialRestoredState = restoreWithDefault(initialState) as State;

const App = (): JSX.Element => {
  return (
    <Router>
      <GlobalStateProvider initialState={initialRestoredState}>
        <ConfigProvider>
          <Route exact path="/" component={LoginPanelMaster} />
          <Route path="/otp" component={OTP} />
        </ConfigProvider>
      </GlobalStateProvider>
    </Router>
  );
};

export default wrapWithMetrics(App, { ...process.env });
